<template>
    <div class="case__conten">
        <NavSecond :banner="icon_stra"></NavSecond>
        <div style="margin-top: 60px">
            <div class="wrapper__w case__det " :style="{'background':'url('+icon_2+')', 'background-size': '100% 100%', 'background-repeat': 'no-repeat'}">
                <div class="case__base relative animate__animated animate__fadeIn">
                    <div class="title"><span>{{casesBase.name}}</span></div>
                    <div class="des">{{casesBase.address}}</div>
                    <div class="city">
                        <span>城市：{{casesBase.city}} </span>
                        <span>面积：{{casesBase.area}}㎡ </span>
                        <span>年份：{{casesBase.year}}</span>
                    </div>
                    <div class="pro__button--sx"  @click="dialogFormVisible = true" v-if="casesBase.can_order == 1">预约参观</div>
                </div>
            </div>
        </div>
        <div class="wrapper__wpd animate__animated animate__fadeIn" style="padding-top: 50px" v-html="casesBase.content"></div>
        <Footer></Footer>


        <el-dialog title="预约参观项目" width="30%" center :visible.sync="dialogFormVisible">
            <el-form :model="form">
                <el-form-item label="您的姓名：" label-width="120px">
                    <el-input v-model="form.name"  clearable></el-input>
                </el-form-item>
                <el-form-item label="您的手机：" label-width="120px">
                    <el-input v-model="form.mobile" clearable></el-input>
                </el-form-item>
                <el-form-item label="所在城市：" label-width="120px">
                    <el-input v-model="form.city" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitFun()" :loading="isSubmit">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import icon_stra from '@/assets/img/case1.png'
    import icon_2 from '@/assets/img/case2.png'
    import NavSecond from '@/components/NavSecond'
    import Footer from '@/layouts/Footer'
    import { isPhone } from '@/libs/common'

    export default {
        name: 'Test',
        data (){
            return {
                icon_stra,icon_2,
                casesBase: {},
                dialogFormVisible: false,
                form: {
                    name: '',
                    mobile: '',
                    city: ''
                },
                id: '',
                isSubmit: false,
            }
        },
        components: {
            NavSecond,Footer
        },
        methods: {
            /**
             * @description详情
             * */
            getDetail (){
                this.$xhr(this.$api.casesDetail, {id: this.id}).then(res => {
                    this.casesBase = res
                })
            },
            /**
             * @description预约
             * */
            submitFun (){
                const {city, name, mobile} = this.form
                if(!name){
                    this.$message.error('请输入称呼')
                    return false
                }
                if(!city){
                    this.$message.error('请输入城市')
                    return false
                }
                if(!mobile){
                    this.$message.error('请输入联系电话')
                    return false
                }
                if (!isPhone(mobile)){
                    this.$message.error('请输入正确的手机号')
                    return false
                }
                this.isSubmit = true
                this.$xhr(this.$api.casesNote, Object.assign(this.form, {case_id: this.id})).then(res => {
                    this.dialogFormVisible = false
                    this.isSubmit = false
                    this.$message({
                        message: '提交成功，稍后会有工作人员联系您，请耐心等待',
                        type: 'success',
                        duration: '3000'
                    });
                })
            },
        },
        mounted() {
            this.$wow.init()
            this.$nextTick(() => {
                this.id = this.$route.query.id
                this.getDetail()
            })
        }
    }
</script>
<style  lang="scss" scoped>
    .case__conten{
        .case__det{
            height: 270px;
            .case__base{
                width: 80%;
                margin: 0 auto;
                padding-top: 60px;
                .title{
                    position: relative;
                    height: auto;
                    line-height: unset;
                    text-align: left;
                    font-size: 32px;
                    font-weight: bold;
                    /*margin-top: 50px;*/
                    span::after{
                        content: '';
                        display: block;
                        position: absolute;
                        left: 0;
                        margin-left: 0;
                        bottom: -20px;
                        width: 32px;
                        height: 4px;
                        background: #F55E1B;
                    }
                }
                .des{
                    font-size: 20px;
                    font-weight: 400;
                    color: #000000;
                    margin-top: 30px;
                }
                .city{
                    font-size: 20px;
                    font-weight: 400;
                    margin-top: 40px;
                    span{
                        margin-right: 10px;
                    }
                }
            }
            /*.pro__button--right{*/
            /*    height: 270px;*/
                .pro__button--sx{
                    cursor: pointer;
                    position: absolute;
                    right: 0%;
                    bottom: 0%;
                    width: 138px;
                    height: 40px;
                    background: #F15315;
                    font-size: 16px;
                    font-weight: 400;
                    color: #FFFFFF;
                    text-align: center;
                    line-height: 40px;
                }
            /*}*/

        }
    }

</style>
